import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { StyledTextContainer } from './SellerNotAvailable.styles'
import { usePostHogAnalytics } from '@gojiraf/analytics'

export const MainParagraph = ({ children }) => {
  const { postHogTrackEvent } = usePostHogAnalytics()

  useEffect(() => {
    postHogTrackEvent('message-no-answer')
  }, [])

  return <StyledTextContainer>{children}</StyledTextContainer>
}

MainParagraph.propTypes = {
  children: PropTypes.element,
}
